module.exports = __webpack_public_path__ + "img/icon_cons.fe15934f.png";